import isEmpty from 'lodash/isEmpty';

export default {
  data() {
    return {
      wizardFilterIdx: null,
    };
  },
  watch: {
    wizardFilterIdx: {
      immediate: true,
      handler(idx) {
        if (idx === null) return;
        this.initWizard();
      },
    },
  },
  methods: {
    cancelWizard() {
      this.wizardFilterIdx = null;
    },
    async initWizard() {
      await this.$nextTick();
      const emptyFilterField = this.parsedFilters[this.wizardFilterIdx].find(
        ({ value }) => value === '' || (Array.isArray(value) && isEmpty(value))
      );
      if (!emptyFilterField) return;

      this.showSuggestedModal(emptyFilterField);
    },

    findNextFieldForEvent() {
      if (this.wizardFilterIdx === null) return;

      const activityFilter = this.parsedFilters[this.wizardFilterIdx];
      const event = this.getFilterEvent(activityFilter);

      if (!event) return;

      const fields = {
        item: {
          events: [
            'answered_question',
            'watched_video',
            'shared',
            'uploaded_video',
            'completed_lesson_item',
          ],
        },
        answer: {
          events: ['answered_question'],
        },
      };

      const suggestedField = Object.keys(fields).find((key) => {
        return (
          fields[key].events.includes(event) &&
          !activityFilter.some(({ field }) => field.field === key)
        );
      });
      if (!suggestedField) return;
      this.addSuggestedField(suggestedField);
    },

    async addSuggestedField(field) {
      this.addFilterRow(this.wizardFilterIdx);
      await this.$nextTick();

      let addedFilter = this.parsedFilters[this.wizardFilterIdx].slice(-1)[0];
      addedFilter.field = this.additionalFields.find((f) => f.field === field);
      this.showSuggestedModal(addedFilter);
    },

    showSuggestedModal(filter) {
      // timeout optional
      setTimeout(() => {
        this.showModal('FieldSelectValue', filter, this.wizardFilterIdx);
      }, 500);
    },

    checkWizard(value, idx) {
      this.cancelWizard();
      this.wizardFilterIdx = idx;
    },
  },
};
